import React, { FC } from 'react';
import { FeedbackModuleContext } from '../types';
import { PanelWrapper, CloseButton } from './Atoms';
import { SpriteIconsLight } from 'src/config/api/models/FontAwesome';

type PanelProps = {
  id: string;
  context: FeedbackModuleContext;
  embedded: boolean;
  onClose?: () => void;
};

export const Panel: FC<PanelProps> = ({ id, context, embedded, onClose, children }) => {
  return (
    <PanelWrapper embedded={embedded} id={id} context={context}>
      {onClose != null && (
        <CloseButton icon={SpriteIconsLight.CANCEL} iconSize="sm" onClick={onClose} />
      )}
      {children}
    </PanelWrapper>
  );
};
